import { render } from "./MainHitchHiking.view.vue?vue&type=template&id=6158fb20"
import script from "./MainHitchHiking.view.vue?vue&type=script&lang=js"
export * from "./MainHitchHiking.view.vue?vue&type=script&lang=js"

import "./MainHitchHiking.view.vue?vue&type=style&index=0&id=6158fb20&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__